import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import "@/i18n";
import App from "@/App";
import { registerServiceWorker } from "@/lib/pwa";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Phase 46 · Feb 2026 — PWA service worker registration.
// Kept out of the React tree so nothing renders before the browser has
// installed the SW. Failures are swallowed silently — the app must
// keep working even if the SW cannot register (private mode, HTTP,
// blocked by the user, etc).
registerServiceWorker();
